import { optionCategory_People } from './category.locstring.json';
import viewSubCategory from './viewSubCategory';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let peopleCategory: OptionCategory = {
    key: 'people',
    titleStringKey: optionCategory_People,
    icon: ControlIcons.People,
    subcategories: [viewSubCategory],
};

export default peopleCategory;
